import { GLOBAL } from 'saddlebag-browser';

import { logErrorWrapper } from '../services/logWrapper';

const getFeatureDecision = (
  configKey: string,
  defaultValue: boolean | string | number,
): boolean | string | number => {
  try {
    const $window = GLOBAL.getWindow();
    return $window.__internal.config[configKey] ?? defaultValue;
  } catch (error) {
    const errorMessage =
      error instanceof Error ? error.toString() : String(error);
    logErrorWrapper(error instanceof Error ? error : new Error(errorMessage), {
      component: 'getFeatureDecision',
      message: `Get config ${configKey} failed: ${errorMessage}`,
    });
    return defaultValue;
  }
};

export default getFeatureDecision;
